import { defineAgent } from '../agent-definition';
import { DOCUMENT_AGENT_TYPE } from '../agent-types';

export const DOCUMENT_AGENT = defineAgent({
  agentType: DOCUMENT_AGENT_TYPE,
  agentName: 'Insights Agent',
  // Already leads with the product name, so the header must not prepend it again.
  prefixNameWithProduct: false,
  triggerLabel: 'Ask about this document',
  inputPlaceholder: 'Ask about this document…',
  starters: [
    {
      title: 'Summarize this document',
      prompt:
        'Summarize this document: what kind of instrument it is, who the parties are, and what interest it conveys. Build the summary from the document itself — read the scanned file and its OCR — and use the interpretation and extracted provisions alongside them. Where the sources disagree, say which one you are relying on and why.',
    },
    {
      title: 'Who conveyed what to whom?',
      prompt:
        'Walk me through the transactions on this document: for each one, the grantors, the grantees, the interest type and the multiplier. Read the instrument itself as well as the recorded interpretation, and flag any transaction, party or interest that appears on the page but is not reflected in the interpretation, or vice versa.',
    },
    {
      title: 'What is the legal description?',
      prompt:
        'What land does this document describe? Quote the legal description from the instrument itself, cite where it appears, and set it against the legal description and location references the interpretation records. Note any difference between them.',
    },
    {
      title: 'Does the interpretation match the document?',
      prompt:
        "Check this document's interpretation against the instrument itself, reading the scanned file and the OCR rather than either alone. Call out anything the interpretation records that the document does not support, and anything in the document the interpretation missed.",
    },
  ],
  // Wording for the `reason` codes this endpoint can emit. Unmapped reasons
  // fall back to the server's own message.
  errorCopy: {
    no_interpretation:
      'This document has not been interpreted yet — the agent can still read its OCR text and extractions.',
  },
});
